import React, { Fragment } from 'react';
import SpinnerDiv from "root/Forms/UI/SpinnerDiv";
import useListboxFetch from "./useListboxFetch";
import { CommonDropdown } from "./CommonDropdown";

const DropdownSchoolTypes = ({ control, name, rules, placeholder, isSearchable, isClearable, isMulti, readOnly, onChange } ) =>
{
    const fields = { url: '/schooltypes', keyFieldName: 'school_type_id', labelFieldName: 'school_type_desc' }

    const [ loading, items ] = useListboxFetch( fields ) ;

    return (
        <Fragment>
            { loading === true && <div className='form-control'><SpinnerDiv/></div> }
            { loading === false && <CommonDropdown items={items} control={control} name={name} rules={rules} placeholder={placeholder} isSearchable={isSearchable} isClearable={isClearable} isMulti={isMulti} readOnly={readOnly} onChange={onChange}/> }
        </Fragment>
    )
}

export default DropdownSchoolTypes;
